import React from 'react';
import { schemaService } from '../../../domain/services/schemaService';
import { imageEntityPropShape } from '../shapes/imageEntityPropShape';

export const ImageSchema = ({ entity }) => {
  const schema = schemaService.getStandaloneImageSchema(entity);
  return schema ? (
    <script
      type="application/ld+json"
      // oxlint-disable-next-line no-danger
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(schema)
      }}
    />
  ) : null;
};

ImageSchema.propTypes = {
  entity: imageEntityPropShape.isRequired
};
